import { useState, useEffect } from "react";
import axios from "axios";
import { Auth } from 'aws-amplify';
import { useAuth } from '../../utils/hooks/use-auth';
 
type useViewInvoicePDFRet<T> = {
  ViewInvoicePDF: (checked: string, initData: Data[]) => void;
};

type Data = {
  target_ym: string;
  contents: any;
};

const baseURL = process.env.REACT_APP_API_ENDPOINT;
const baseS3Path = "s3://p3-cust-dev-pdf/esb_receive/";

// トークン取得
const getCurrentUserToken = async () => {
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error) {
    console.log(error);
  }
};

// メインフック
export function useViewInvoicePDF(): useViewInvoicePDFRet<Data> {
  
  const ViewInvoicePDF = async (targetDate: string, pageData: Data[]) => {
    localStorage.removeItem('token');
    const token = await getCurrentUserToken();
    const downloadFiles: string[] = [];
    pageData.forEach((obj) => {
      if(obj.target_ym === targetDate){
        const contents = obj.contents;
        const targetContents = contents.filter((objChild: any) => {
          return objChild["file_type"] === "請求書";
        });
        if (targetContents.length > 0){
          downloadFiles.push(targetContents[0]["system_file_name"]);
        }
      }
    });
    
    if(downloadFiles.length < 1){
      window.alert("ダウンロード対象のファイルが存在しません");
      return;
    }
    
    axios.request({
        url: baseURL + "/billing-inquery-invoice-download",
        method: "post",
        headers: { 
          Accept: "application/pdf",
          Authorization: token,
        },
        data:{
          "downloadFiles": downloadFiles
        }
    })
    .then((response) => {
      const blob: Blob = toBlobPdf(response.data, "application/pdf");
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank")  // pdfを別タブで表示
    })
    .catch((error) => {
      console.log(error);
    });
  };
  
  function toBlobPdf(base64: string, mime_ctype: string): Blob {
    // 日本語の文字化けに対処するためBOMを作成する。
    var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    var bin = atob(base64.replace(/^.*,/, ''));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    var blob = new Blob([bom, buffer.buffer], {
        type: mime_ctype,
    });
    return blob;
  };
  
  return {
    ViewInvoicePDF
  };
}
